import React from 'react';
import { motion } from 'framer-motion';
import { Home, Share2, Crown, Target, ArrowRight } from 'lucide-react';
import { Button } from './Button';

const steps = [
  {
    icon: Home,
    title: 'Create a room',
    description: 'Start a new game and get a room code to share',
  },
  {
    icon: Share2,
    title: 'Invite friends',
    description: 'Share the link or code - no signup needed',
  },
  {
    icon: Crown,
    title: 'Declare trump',
    description: 'Use your jokers to claim the trump suit',
  },
  {
    icon: Target,
    title: 'Win tricks',
    description: 'Collect points and level up your team',
  },
];

export function HowToPlay() {
  return (
    <section className="py-16 bg-white px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-black mb-4">
            How to Play
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                delay: index * 0.1,
                duration: 0.5,
              }}
              className="text-center"
            >
              <div className="w-14 h-14 mx-auto bg-white rounded-full shadow-sm flex items-center justify-center mb-4 text-black border border-gray-200">
                <step.icon className="w-6 h-6" />
              </div>
              <h3 className="text-base font-bold text-black mb-2">
                {step.title}
              </h3>
              <p className="text-gray-500 text-xs">{step.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.pagat.com/kt5/tractor.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="secondary" className="group">
              Learn the rules
              <ArrowRight className="ml-2 w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
